import { Box, Skeleton } from '@mui/material';

import { LAYOUT_MAX_WIDTH } from '@/constants';

export const CategoryNavLinksSkeleton = () => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 0,
      position: 'sticky',
      top: { xs: '56px', sm: '60px', md: '64px' },
      left: 0,
      right: 0,
      zIndex: 1000,
      bgcolor: 'background.default',
      width: '100%',
      mx: { xs: -1.5, sm: -2, md: -3, lg: -4 },
      px: { xs: 1.5, sm: 2, md: 3, lg: 4 },
    }}
  >
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: 1,
        width: '100%',
        maxWidth: LAYOUT_MAX_WIDTH,
        mt: 2,
        mx: 'auto',
        px: { xs: 0.5, sm: 1 },
        overflowX: 'auto',
        overflowY: 'visible',
        '&::-webkit-scrollbar': { display: 'none' },
        scrollbarWidth: 'none',
      }}
    >
      {[...Array(8)].map((_, index) => (
        <Skeleton
          key={index}
          variant="rectangular"
          width={80}
          height={32}
          sx={{ borderRadius: 1, flexShrink: 0 }}
        />
      ))}
    </Box>
  </Box>
);
